import React from 'react';
import PropTypes from 'prop-types';
import Input from '../Input/Input';
import Button from '../Button/GlyphedButton';
import Title from '../Title/Title';
import { SEARCH_GLYPH } from '../../../const/Glyphicons';
import './Searcher.scss';

const Searcher = (props) => {
    return (
        <div 
            className="col-xs-12"
            id="picker-input">
            <Title
                title={props.title}
                large/>
            <div className="col-xs-12 picker-input">
                <Input
                    className="col-xs-12 col-sm-offset-6 form-control"
                    onChange={props.inputTextChanged}
                    onKeyPress={props.inputKeyPressed}
                    placeholder={props.inputPlaceholder}
                    type={props.inputType}
                    value = {props.inputValue}/>
                <Button
                    onClick={props.searchButtonClicked}
                    label="Szukaj"
                    glyph={SEARCH_GLYPH} />
            </div>
        </div>
    );
};

Searcher.propTypes = {
    inputKeyPressed: PropTypes.func,
    inputPlaceholder: PropTypes.string,
    inputTextChanged: PropTypes.func,
    inputType: PropTypes.string,
    inputValue: PropTypes.string,
    searchButtonClicked: PropTypes.func,
    title: PropTypes.string
};

export default Searcher;


// WEBPACK FOOTER //
// ./src/components/base/Searcher/Searcher.js